import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import Logo from '../logo';
import CommonMenu from './components/commonMenu';
import AdminMenu from './components/adminMenu';

import request from '../../utils/request';
import { useLocaleActionsContext } from '../../context/LocaleContext';
import { localeEn, localeFr } from '../../misc';

const MobileHeader = ({ locale, userRights = null }) => {
  const { isAdminBandVisible } = userRights;

  const history = useHistory();
  const setLocale = useLocaleActionsContext();
  const languageLabel = locale === localeEn ? 'FR' : 'EN';

  const [sidebarVisible, setSidebarVisible] = useState(false);

  const handleLogout = () => {
    setSidebarVisible(false);
    request
      .get('/orders/unlock')
      .then(() => {
        localStorage.clear();
        history.push('/');
        window.location.reload();
      })
      .catch(err => {
        throw err;
      });
  };

  const handleLocaleChange = () => {
    setSidebarVisible(false);
    setLocale(locale === localeEn ? localeFr : localeEn);
  };

  return (
    <header className="mobile-header">
      <div className="mobile-nav-container">
        <Logo locale={locale} userRights={userRights} />
        <button
          type="button"
          className={`hamburger-menu-main ${sidebarVisible && 'open'}`}
          onClick={() => setSidebarVisible(!sidebarVisible)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
      {sidebarVisible && (
        <div className="header-content-main">
          <aside className="mobile-side-container">
            <div className="action-section">
              <button
                type="button"
                onClick={handleLocaleChange}
                className="language-container"
              >
                {languageLabel}
              </button>
              <button
                type="button"
                onClick={handleLogout}
                className="logout-container"
              >
                Logout &rarr;
              </button>
            </div>
            <nav className="mobile-navbar">
              <CommonMenu
                locale={locale}
                setSidebarVisible={setSidebarVisible}
              />
              {isAdminBandVisible && (
                <AdminMenu setSidebarVisible={setSidebarVisible} />
              )}
            </nav>
          </aside>
        </div>
      )}
    </header>
  );
};

MobileHeader.propTypes = {
  locale: PropTypes.string.isRequired,
  userRights: PropTypes.shape({
    isStatusEditable: PropTypes.bool,
    isUserEditable: PropTypes.bool,
    canAssignOrder: PropTypes.bool,
    isAdminBandVisible: PropTypes.bool,
    isUserPageVisible: PropTypes.bool,
    isSOVDashboardVisible: PropTypes.bool,
    isQuoteApprovalDashboardVisible: PropTypes.bool,
    isBulkUploadVisible: PropTypes.bool
  })
};

export default MobileHeader;
